import React from 'react';
import { Field, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { _RadioWrapper as RadioWrapper } from './Radio.style';
import { _Label as Label } from '../../Styled/Label';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';

export const Radio = ({ id, props }) => {
  const { label, options, required, description } = props;
  const optionsArray = options.split('\n');

  return (
    <RadioWrapper>
      <Label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</Label>
      {description ? <FieldDescription>{description}</FieldDescription> : ''}
      {optionsArray.map((option, index) => (
        <div key={index}>
          <Field id={`${id}-${option}`} name={`form.${props.label}`} type='radio' value={option} required={required} />
          <Label htmlFor={`${id}-${option}`}>{option}</Label>
        </div>
      ))}
    </RadioWrapper>
  );
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.string.isRequired,
    required: PropTypes.bool,
    name: PropTypes.string,
  }).isRequired,
};
